/* =========================================================================
 * Featured collection (Rapi tiers) — client behavior
 * -------------------------------------------------------------------------
 * - Mini pack-size chips (radio group with arrow-key navigation)
 * - Chip selection sets the native product form's quantity input and
 *   updates the displayed pack total / was-price / per-can price
 * - Add to Cart is the theme's own product-form element; the actual
 *   discount is applied in the cart by the Rapi Bundle discount function
 *
 * All maths in integer cents, truncating like the Liquid server render.
 * ========================================================================= */
(function () {
  'use strict';

  if (window.__TSO_MINI_INIT__) return;
  window.__TSO_MINI_INIT__ = true;

  /* ---------------------------------------------------- formatting helpers */
  /** Format integer cents using Shopify's money format string. */
  function formatMoney(cents, fmt) {
    var val = cents / 100;
    if (!fmt) return val.toFixed(2);

    function withDelims(num, thousands, decimal) {
      var parts = num.toFixed(2).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + decimal + parts[1];
    }

    try {
      if (fmt.indexOf('amount_no_decimals_with_comma_separator') !== -1) {
        return fmt.replace(/\{\{[^}]+\}\}/g, withDelims(Math.round(val), '.', ',').replace(/,00$/, ''));
      }
      if (fmt.indexOf('amount_with_comma_separator') !== -1) {
        return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDelims(val, '.', ','));
      }
      if (fmt.indexOf('amount_no_decimals') !== -1) {
        return fmt.replace(/\{\{[^}]+\}\}/g, String(Math.round(val)));
      }
      return fmt.replace(/\{\{[^}]+\}\}/g, withDelims(val, ',', '.'));
    } catch (e) {
      return val.toFixed(2);
    }
  }

  /* -------------------------------------------------------------- pricing */
  function applyTier(card, chip) {
    var unit = parseInt(card.getAttribute('data-unit'), 10) || 0;
    var compare = parseInt(card.getAttribute('data-compare'), 10) || 0;
    var qty = parseInt(chip.getAttribute('data-qty'), 10) || 1;
    var pct = parseInt(chip.getAttribute('data-pct'), 10) || 0;

    var gridEl = card.closest('[data-money-format]');
    var fmt = gridEl ? gridEl.getAttribute('data-money-format') : '';

    /* Top of card: per-can now/was. ATC button: pack total. */
    var total = Math.floor((unit * qty * (100 - pct)) / 100);
    var percan = Math.floor((unit * (100 - pct)) / 100);
    var wasPercan = compare > 0 ? compare : pct > 0 ? unit : 0;

    var priceEl = card.querySelector('[data-tso-price]');
    var totalEl = card.querySelector('[data-tso-total]');
    var wasEl = card.querySelector('[data-tso-was]');
    var percanEl = card.querySelector('[data-tso-percan]');
    var atcPriceEl = card.querySelector('[data-tso-atc-price]');
    var btnQtyEl = card.querySelector('[data-tso-btn-qty]');
    var btnUnitEl = card.querySelector('[data-tso-btn-unit]');

    if (totalEl) totalEl.textContent = formatMoney(total, fmt);
    if (percanEl) percanEl.textContent = formatMoney(percan, fmt);
    if (atcPriceEl) atcPriceEl.textContent = formatMoney(total, fmt);
    if (btnQtyEl) btnQtyEl.textContent = String(qty);
    if (btnUnitEl) btnUnitEl.textContent = qty === 1 ? 'can' : 'cans';
    if (wasEl) {
      if (wasPercan > 0) {
        wasEl.textContent = formatMoney(wasPercan, fmt);
        wasEl.hidden = false;
      } else {
        wasEl.textContent = '';
        wasEl.hidden = true;
      }
    }
    if (priceEl) priceEl.classList.toggle('price--on-sale', wasPercan > 0);

    var qtyInput = card.querySelector('[data-tso-qty]');
    if (qtyInput) qtyInput.value = String(qty);
  }

  function selectChip(card, chip) {
    var chips = card.querySelectorAll('[data-tso-chip]');
    chips.forEach(function (c) {
      var isMatch = c === chip;
      c.setAttribute('aria-checked', isMatch ? 'true' : 'false');
      c.setAttribute('tabindex', isMatch ? '0' : '-1');
    });
    applyTier(card, chip);
  }

  /* ------------------------------------------------------------ listeners */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-tso-chip]');
    if (!chip || chip.disabled) return;
    var card = chip.closest('[data-tso-card]');
    if (!card) return;
    selectChip(card, chip);
  });

  /* Roving radio-group keyboard support */
  document.addEventListener('keydown', function (e) {
    var chip = e.target.closest && e.target.closest('[data-tso-chip]');
    if (!chip) return;

    var group = chip.closest('[data-tso-chips]');
    var card = chip.closest('[data-tso-card]');
    if (!group || !card) return;

    var chips = Array.prototype.slice.call(group.querySelectorAll('[data-tso-chip]:not([disabled])'));
    var idx = chips.indexOf(chip);
    if (idx === -1) return;

    var next = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      next = chips[(idx + 1) % chips.length];
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      next = chips[(idx - 1 + chips.length) % chips.length];
    } else if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      selectChip(card, chip);
      return;
    }

    if (next) {
      e.preventDefault();
      selectChip(card, next);
      next.focus();
    }
  });
})();

/* TSO: se till att det förvalda pack-chipet (30) syns direkt på mobil —
   chipsraden scrollas så valt chip centreras när raden är overflowad. */
(function () {
  function centerSelectedChips(root) {
    (root || document).querySelectorAll('.tso-mini__chips').forEach(function (chips) {
      if (chips.scrollWidth <= chips.clientWidth + 4) return;
      var sel = chips.querySelector('[aria-checked="true"]');
      if (!sel) return;
      var cr = chips.getBoundingClientRect();
      var sr = sel.getBoundingClientRect();
      var target = (sr.left - cr.left + chips.scrollLeft) - (chips.clientWidth - sr.width) / 2;
      chips.scrollLeft = Math.max(0, target);
    });
  }
  var run = function () { centerSelectedChips(); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && ((n.matches && n.matches('.tso-mini__chips')) || (n.querySelector && n.querySelector('.tso-mini__chips')))) {
          run();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
